<template>
	<div class="dropdown">
		<a href="javascript:void(0);" class="link-dark hstack gap-2 align-items-center py-1 ps-3 pe-2 border rounded-pill shadow-2-hover bg-white" :style="style" data-bs-toggle="dropdown" aria-expanded="false">
			<i class="bi bi-list text-lg"></i>
			<UserAvatarRounded :user="user" size="xs" />
		</a>
		<div class="dropdown-menu dropdown-menu-end px-0 mt-2 rounded-4">
			<div class="dropdown-header vstack lh-xs">
				<span class="text-heading text-md fw-bold text-truncate">{{ user.name }}</span>
				<span class="text-muted fw-semibold text-truncate">{{ user.email }}</span>
			</div>
			<div class="dropdown-divider" v-if="user.general_roles.length > 0"></div>
			<div class="overflow-y-auto" style="min-height: 75px; max-height: calc(100vh - 170px);">
				<template v-if="user.general_roles.length > 0">
					<template v-if="user.general_roles.includes('seller')">
						<router-link :to="{ name: 'customer.index' }" class="dropdown-item rounded-0"><i class="bi bi-briefcase pe-2"></i>Clientes</router-link>
					</template>
					<template v-if="user.general_roles.includes('seller')">
						<router-link :to="{ name: 'sale.index' }" class="dropdown-item rounded-0"><i class="bi bi-receipt pe-2"></i>Ventas</router-link>
					</template>
					<template v-if="['admin', 'leader'].some(valor => user.general_roles.includes(valor))">
						<router-link :to="{ name: 'company.select' }" class="dropdown-item rounded-0"><i class="bi bi-buildings pe-2"></i>Empresas</router-link>
					</template>
				</template>
				<LayoutMenuUserCompany v-if="route.meta?.companyArea" />
				<div class="dropdown-divider"></div>
				<router-link :to="{ name: 'account.setting.index' }" @click.native="setNext" class="dropdown-item rounded-0"><i class="bi bi-person-lines-fill pe-2"></i>Mi perfil</router-link>
				<router-link :to="{ name: 'auth.logout' }" @click.native="setNext" class="dropdown-item rounded-0"><i class="bi bi-box-arrow-left pe-2"></i>Cerrar sesión</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	import { useRoute } from 'vue-router';
	import store from '@/store';

	export default {
		props: {
			user: Object,
			style: Object,
			size: {
				type: String,
				default: 'md'
			}
		},
		setup() {
			const route = useRoute();

			const setNext = () => {
				store.dispatch('redirect/setNext', route.fullPath);
			}

			return { route, setNext };
		}
	}
</script>

<style scoped>
	.dropdown-menu {
		min-width: 200px;
		max-width: 220px;
	}
</style>